// extracted by mini-css-extract-plugin
export default {"deteleme":"DeleteProfilePopup_deteleme__wakQQ","signOutButton":"DeleteProfilePopup_signOutButton__hHbWf"};